import { EDIT_LISTING_PROPERTY_TYPE,
         CLOSE_LISTING_PROPERTY_TYPE,
         PENDING_SUBMIT_LISTING_PROPERTY_TYPE,
         COMPLETE_SUBMIT_LISTING_PROPERTY_TYPE,
         FAILED_SUBMIT_LISTING_PROPERTY_TYPE
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertypropertytypeediting: false
}


const mlListingPropertyType = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_PROPERTY_TYPE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertypropertytypeediting: true
        }

        case CLOSE_LISTING_PROPERTY_TYPE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertypropertytypeediting: false
        }

        case PENDING_SUBMIT_LISTING_PROPERTY_TYPE: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_PROPERTY_TYPE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_PROPERTY_TYPE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingPropertyType